export async function postToSheet(formType: 'contact' | 'quote', form: HTMLFormElement) {
  const url = import.meta.env.VITE_APPS_SCRIPT_URL
  if (!url) {
    throw new Error('Missing Google Apps Script URL')
  }

  const fd = new FormData(form)
  const payload: Record<string, any> = {}

  fd.forEach((value, key) => {
    if (payload[key] !== undefined) {
      payload[key] = Array.isArray(payload[key]) ? [...payload[key], value] : [payload[key], value]
    } else {
      payload[key] = value
    }
  })

  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ formType, payload })
  })

  const json = await res.json().catch(() => ({}))
  if (!res.ok || !json.ok) {
    throw new Error(json.error || 'Submission failed')
  }

  return json
}
